/**
 *
 * TransactionsPopup
 *
 * @version 1.0.0
 * @author Vittorio
 * @since 04-Nov-2022
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PortalModal from 'Components/PortalModal/PortalModalContainer';
import PortalAnchorButton from 'Components/PortalAnchorButton';
import PortalTable from 'Components/PortalTable';
import PortalNoElementFound from 'Components/PortalNoElementFound';
import { formatAmount } from 'Utility/utils';
import formattedMessage from '../../modules/languageModule';
import style from './TransactionsPopup.scss';

const TransactionsPopup = (props) => {
	const navigate = useNavigate();

	useEffect(() => {
		props.actions.fetchTransactionFind(props.payload);
	}, []);

	const modifiedTransactionsData = props.transactionsData && props.transactionsData.length > 0 ?
	props.transactionsData.map(obj => {
        return {
            amount: formatAmount(obj.amount, obj.currency),
            currency: obj.currency ,
            groupName: obj.groupName,
            merchantName: obj.merchantName,
            merchantOrderId: obj.merchantOrderId ,
            paymentId: obj.paymentId ,
            registerId: obj.registerId ,
            storeName: obj.storeName ,
            transactionId: obj.transactionId ,
            transactionStatus: obj.transactionStatus ,
            transactionChannel: obj.transactionChannel ,
            paymentMethod: obj.paymentMethod ,
            creationDate: obj.creationDate ,
            updateDate: obj.updateDate,
            username: obj.username
        };
    }) : [];

	return (
		<PortalModal className={style.container} closeIcon isBig>
			<Grid className={style.content}>
				<Typography variant='body1' align='left' className={style.subtitle}>
					<FormattedMessage {...formattedMessage.subtitle} />
				</Typography>
				{!props.transactionsLoading && props.transactionsData.length === 0 ? (
					<PortalNoElementFound />
				) : (
					<PortalTable
						simpleTable
						tHeadItems={[
							formattedMessage.transactionId,
							formattedMessage.merchantName,
							/* formattedMessage.acquirer, */
							formattedMessage.currency,
							formattedMessage.amount,
							formattedMessage.creationDate,
							formattedMessage.transactionStatus,
						]}
						tBodyItems={modifiedTransactionsData}
						isLoading={props.transactionsLoading}
						tBodyItemsToShow={[
							{ fieldName: 'transactionId', formattedMessageScope: null },
							{ fieldName: 'merchantName', formattedMessageScope: null },
							/* { fieldName: 'acquirer', formattedMessageScope: null }, */
							{ fieldName: 'currency', formattedMessageScope: null },
							{ fieldName: 'amount', formattedMessageScope: null },
							{ fieldName: 'creationDate', formattedMessageScope: null },
							{ fieldName: 'transactionStatus', formattedMessageScope: null },
						]}
					/>
				)}
			</Grid>
			<Grid className={style.action}>
				<PortalAnchorButton
					textTransform='isUppercase'
					contentText={formattedMessage.anchor}
					onClickAction={() => (
						navigate('/transactions'), props.actions.doSetItemToShowDetail(props.payload), props.actions.goPopup('')
					)}
				/>
			</Grid>
		</PortalModal>
	);
};

TransactionsPopup.propTypes = {
	// Add here some propTypes
	actions: PropTypes.objectOf(PropTypes.func),
	payload: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
	transactionsLoading: PropTypes.bool,
	transactionsData: PropTypes.object,
};

TransactionsPopup.defaultProps = {
	// Add here some default propTypes values
	transactionsLoading: false,
	transactionsData: {},
};
export default TransactionsPopup;
